<!-- 收藏看完结果页 -->
<template>
  <div>
    <div class="my_Body">
      <div class="title">
        <span>{{descText}}</span>
      </div>
      <div class="img">
        <img src="@/assets/img/h5/newQuestiongreat@2x.png" />
      </div>
      <div @click="goPage" class="viewWarning btn">{{btnText}}</div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      initData: '',
      title: ''
    };
  },
  computed: {
    descText: function () {
      if (this.initData.type == "warning") {
        return "赞！温故而知新！"
      } else {
        return "赞！收藏的试题看完了！"
      }
    },
    btnText: function () {
      if (this.initData.type == "warning") {
        return "返回错题本"
      } else {
        return "返回试题收藏"
      }
    }
  },
  watch: {},
  created () {

  },
  mounted () {

  },
  destroyed () { }, //生命周期 - 销毁完成
  //方法集合
  methods: {
    goPage () {
      this.$router.back()
    },
  },
}
</script>
<style  scoped>
.header {
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: bold;
  padding-bottom: 0.84375rem;
  border-bottom: 1px solid #eeeeee;
}
.header .title {
  width: 100%;
  text-align: center;
  font-size: 1.2rem;
}
.my_Body {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 90vh;
  align-items: center;
}
.img {
  width: 8.75rem;
  height: 8.75rem;
}
.title {
  font-weight: 600;
}
.img img {
  width: 100%;
  height: 100%;
}
.btn {
  width: 14.0625rem;
  height: 2.0625rem;
  border-radius: 0.3125rem;
  background: linear-gradient(
    -3deg,
    rgba(74, 199, 255, 1),
    rgba(77, 167, 249, 1)
  );
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  font-weight: 600;
  font-size: 0.9375rem;
  color: #ffffffff;
}
</style>